export default __webpack_public_path__ + "static/media/NotoSans-Light.2cfb54d9.ttf";